






















































import Vue from 'vue'
import { faMapMarker, faPhone, faRoad } from '@fortawesome/free-solid-svg-icons'

export default Vue.extend({
  props: {
    dealer: {
      type: Object,
      required: true
    },
    customClass: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    icons: {
      mapMarker: faMapMarker,
      phone: faPhone,
      road: faRoad
    }
  }),
  methods: {
    stopPropagation(e) {
      e.stopPropagation()
    }
  }
})
